import React from "react";
import "../assets/styles/components/footer.css";

function Footer() {
    return (
        <footer className="site-footer">
            <p>© {new Date().getFullYear()} Anton Korolov. All rights reserved.</p>
        </footer>
    );
}

export default Footer;
